import { Question } from '../../../types';
import { DescriptionField, MaxLimitField, TagsField } from '../../components';

interface PhotoQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function PhotoQuestionConfig({ question, onEdit }: PhotoQuestionConfigProps) {
  return (
    <div className="space-y-3">
      <DescriptionField
        value={question.description || ''}
        onChange={(value) => onEdit(question.id, { description: value })}
      />

      <MaxLimitField
        label="Máx. fotos"
        value={question.maxPhotos || 0}
        onChange={(value) => {
          if (value !== undefined) {
            onEdit(question.id, { maxPhotos: value });
          }
        }}
      />

      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
